import { render, staticRenderFns } from "./InsightCustom.vue?vue&type=template&id=4e0b88c9&scoped=true&"
import script from "./InsightCustom.vue?vue&type=script&lang=js&"
export * from "./InsightCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b88c9",
  null
  
)

export default component.exports